<template>
  <div>
    <x-toolbar
      :title="pageTitle"
      :tabs="hasTabs"
      :full-width="true"
      :extension="hasTabs"
    >
      <template
        v-if="hasTabs"
        #extension
      >
        <v-tabs
          v-model="tab"
          background-color="primary lighten-1"
          grow
        >
          <v-tabs-slider
            color="accent"
          />
          <v-tab
            v-for="item of tabItems"
            :key="item.label"
          >
            {{ $t('tasks.moveProducts.navigation.' + item.label) }}
          </v-tab>
        </v-tabs>
      </template>
    </x-toolbar>
    <template v-if="details">
      <template v-if="assignable">
        <TaskAssignButton
          :loading="loading"
          @assign="assign"
        />
      </template>
      <template v-if="hasTabs">
        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="item of tabItems"
            :key="item.label"
          >
            <component
              :is="item.component"
              :api="API"
              :task-info="taskInfo"
            />
          </v-tab-item>
        </v-tabs-items>
      </template>
      <template v-else>
        <MoveProductsAssignment
          :task-info="taskInfo"
        />
      </template>
    </template>
    <template v-else>
      <v-progress-linear
        indeterminate
      />
    </template>
  </div>
</template>

<script>
    import {TaskMoveProductsAPI as API} from "@/api/TaskMoveProductsAPI";
    import {RouteParamsMapperMixin} from "@/app/mixins/RouteParamsMapperMixin";
    import TaskAssignButton from "@/app/tasks/components/TaskAssignButton.component";
    import {taskNames, taskTypes} from "@/enum/task_type";
    import {assign} from "@/utils/object";
    import {tabTitle} from "@/utils/string";
    import MoveProductsAssignment from "@/app/tasks/moveProducts/components/MoveProductsAssignment.component";
    import MoveProductsMove from "@/app/tasks/moveProducts/components/MoveProductsMove.component";
    import TaskDefaultOverview from "@/app/tasks/components/TaskDefaultOverview.component";
    import {ACLMixin} from "@/app/mixins/ACLMixin";
    import {TaskStateMixin} from "@/app/mixins/TaskStateMixin";
    import {TaskMoveProductsType} from "@/enum/task_move_products_type";
    import {TaskAssignMixin} from "@/app/mixins/TaskAssignMixin";
    import {BarcodeListenerMixin} from "@/app/mixins/BarcodeListenerMixin";
    import {EventsListenerMixin} from "@/app/mixins/EventsListenerMixin";

    export default {
        name: "MoveProductsShow",
        components: {TaskAssignButton, MoveProductsAssignment},
        mixins: [ACLMixin, TaskStateMixin, TaskAssignMixin, EventsListenerMixin, BarcodeListenerMixin, RouteParamsMapperMixin],
        data: () => ({
            API: API,
            loading: false,
            type: taskTypes.MOVE_PRODUCTS,
            details: null,
            tab: null,
            ready: false
        }),
        computed: {
            events: function () {
                return {
                    'onBarcodeRead': this.activateTab,
                };
            },
            typeName: function () {
                return this.$t(taskNames[this.type]);
            },
            pageTitle: function () {
                const title = '#' + this.taskId + ' ' + this.typeName;
                if (!this._inactive) {
                    document.title = tabTitle(title);
                }
                return title;
            },
            movementType: function () {
                if (this.ready) {
                    if (this.details.source_location === null) {
                        if (this.details.destination_location === null) {
                            return TaskMoveProductsType.MANYTOMANY;
                        } else {
                            return TaskMoveProductsType.COLLAPSE;
                        }
                    } else {
                        if (this.details.destination_location === null) {
                            return TaskMoveProductsType.DISTRIBUTE;
                        } else {
                            return TaskMoveProductsType.RELOCATE;
                        }
                    }
                } else {
                    return -1;
                }
            },
            taskInfo: function () {
                return {
                    details: this.details,
                    tab: this.tab,
                    taskId: this.taskId,
                    movementType: this.movementType
                };
            },
            tabItems: function () {
                return [{
                    label: 'assignment',
                    component: MoveProductsAssignment
                }]
                    .concat(
                        (
                            this.isStorekeeper || this.isChief
                        ) ? [{
                            label: 'moveProducts',
                            component: MoveProductsMove
                        }] : [])
                    .concat(
                        (
                            this.isOpenState && (
                                (this.isStorekeeper && this.assignedToCurrentUser && this.isInProgress) || this.isChief
                            )
                        ) ? [{
                            label: 'finish',
                            component: TaskDefaultOverview
                        }] : []);
            },
            hasTabs: function () {
                return this.tabItems.length > 1;
            }
        },
        createdOrActivated: function (lifeCycleHook) {
            this.getTask(lifeCycleHook);
        },
        methods: {
            getTask: function (lifeCycleHook) {
                return API.get(this.taskId, true)
                    .then(response => {
                        if (lifeCycleHook === this.LifeCycleHook.CREATED) {
                            this.details = response.data;
                        } else {
                            assign(this.details, response.data);
                        }
                        this.ready = true;
                    }).catch(err => {
                        this.snack(err);
                        this.$router.push('/');
                    });
            }
        }
    };
</script>

<style scoped>

</style>
